import { openModal } from '@core/components/ModalStack';
import { SelectRTEModalProps } from './SelectRTEModal';

export async function openSelectRTEModal(props: SelectRTEModalProps) {
  const { SelectRTEModal } = await import('./SelectRTEModal');

  openModal(SelectRTEModal, props);
}
